import { ErrorMessage, Field, Formik } from 'formik'
import { ModalForm } from 'modules/app/styles'
import { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import { FormGroup, Input, Label, Modal, ModalBody, UncontrolledTooltip } from 'reactstrap'
import * as yup from 'yup'
import { CustomButton, EyeIcon } from 'modules/auth/styles'
import { ButtonLoader } from 'utils/storageUtils'
import { restoreSession } from 'store/actions'
import { IconContext } from 'react-icons'
import { AiFillInfoCircle } from 'react-icons/ai'
import apiService from 'utils/apiService'
import { history } from 'store/store'
import { handleApiError } from 'utils/helpers'
import { toast } from 'react-toastify'
import { BsEye, BsEyeSlash } from 'react-icons/bs'

export const ChangePasswordModal = (props) => {
  const [is_submitting, set_is_submitting] = useState('')
  const [saved, set_saved] = useState('')
  const [passwordVisible, setPasswordVisible] = useState(false)
  const [newPasswordVisible, setNewPasswordVisible] = useState(false)
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false)
  const currentPasswordRef = useRef()
  useEffect(() => {
    setTimeout(() => {
      if (currentPasswordRef && currentPasswordRef.current) {
        currentPasswordRef.current.focus()
      }
    }, 200)
  }, [currentPasswordRef])

  return (
    <Modal centered fade={false} isOpen={true} className='' toggle={() => props.set_showChangePassword(false)}>
      <ModalBody>
        {/* Email */}
        <ModalForm>
          <div className='title'>Set new password</div>
        </ModalForm>
        <br />
        {/* Password */}
        <Formik
          enableReinitialize
          initialValues={{
            email: props.user.email,
            currentPassword: '',
            newPassword: '',
            confirmPassword: ''
          }}
          validationSchema={yup.object().shape({
            currentPassword: yup.string().required(),
            newPassword: yup.string().required('New password is required').min(6, 'Minimum 6 characters required.'),
            confirmPassword: yup.string().oneOf([yup.ref('newPassword'), null], 'Passwords must match')
          })}
          onSubmit={async (values) => {
            try {
              set_is_submitting('password')
              const data = { ...values }
              await apiService('auth/changePassword', data, 'post', true)
              set_saved('password')
              toast.success(`Password Updated... You'll be logged out.`)
              setTimeout(() => history.replace('/login'), 3000)
            } catch (error) {
              handleApiError(error)
            }
            set_is_submitting('')
            setTimeout(() => {
              set_saved('')
            }, 2000)
          }}>
          {(formikProps) => (
            <ModalForm onSubmit={formikProps.handleSubmit} autoComplete='off' style={{ maxWidth: 400 }}>
              <Field name='currentPassword'>
                {({ field }) => (
                  <FormGroup className='mb-5'>
                    <Input
                      {...field}
                      type={passwordVisible ? 'text' : 'password'}
                      innerRef={currentPasswordRef}
                      id='currentPassword'
                      className={`login-input ${field.value ? 'has-value' : ''} ${formikProps.errors.currentPassword ? 'error' : ''}`}
                    />
                    <Label htmlFor='currentPassword'>Current password</Label>
                    {field.value && <EyeIcon onClick={() => setPasswordVisible(!passwordVisible)}>{!passwordVisible ? <BsEye size={20} /> : <BsEyeSlash size={20} />}</EyeIcon>}
                  </FormGroup>
                )}
              </Field>
              <Field name='newPassword'>
                {({ field }) => (
                  <FormGroup className='mb-5'>
                    <Input
                      {...field}
                      type={newPasswordVisible ? 'text' : 'password'}
                      id='newPassword'
                      className={`login-input ${field.value ? 'has-value' : ''} ${formikProps.errors.newPassword ? 'error' : ''}`}
                    />
                    <Label htmlFor='newPassword'>
                      New password
                      <IconContext.Provider value={{ style: { marginLeft: 5 } }}>
                        <AiFillInfoCircle tabIndex='-1' id='passwordTip' />
                      </IconContext.Provider>
                      <UncontrolledTooltip target='passwordTip'>
                        A minimum of 6 characters is required. We recommend that you include alphanumeric and special characters like <code>*.!@$%^&(){}[]</code>
                      </UncontrolledTooltip>
                    </Label>
                    <ErrorMessage name='newPassword' className='error-message' component='div' />
                    {field.value && <EyeIcon onClick={() => setNewPasswordVisible(!newPasswordVisible)}>{!newPasswordVisible ? <BsEye size={20} /> : <BsEyeSlash size={20} />}</EyeIcon>}
                  </FormGroup>
                )}
              </Field>
              <Field name='confirmPassword'>
                {({ field }) => (
                  <FormGroup className='mb-5'>
                    <Input
                      {...field}
                      type={confirmPasswordVisible ? 'text' : 'password'}
                      id='confirmPassword'
                      className={`login-input ${field.value ? 'has-value' : ''} ${formikProps.errors.confirmPassword ? 'error' : ''}`}
                    />
                    <Label htmlFor='confirmPassword'>Confirm password</Label>
                    <ErrorMessage name='confirmPassword' className='error-message' component='div' />
                    {field.value && <EyeIcon onClick={() => setConfirmPasswordVisible(!confirmPasswordVisible)}>{!confirmPasswordVisible ? <BsEye size={20} /> : <BsEyeSlash size={20} />}</EyeIcon>}
                  </FormGroup>
                )}
              </Field>
              <CustomButton type='submit' className={`gray ${saved === 'password' && 'green'}`} disabled={is_submitting === 'password' || saved === 'password'}>
                {saved === 'password' ? 'Password changed' : 'Change Password'} {is_submitting === 'password' && <ButtonLoader />}
              </CustomButton>
            </ModalForm>
          )}
        </Formik>
      </ModalBody>
    </Modal>
  )
}

const mapStateToProps = (state) => ({
  user: state.auth.user
})

const mapDispatchToProps = (dispatch) => ({
  restoreSession: () => dispatch(restoreSession())
})

export default connect(mapStateToProps, mapDispatchToProps)(ChangePasswordModal)
